import { StyleSheet, TouchableOpacity, View, ViewProps, useWindowDimensions } from 'react-native'
import { Color, Spacing, useKeyboardShortcut } from 'zens-storybook'
import { useNumberParams, useBooleanParams, Link } from 'zens-router'
import { InsightsLiveKioskHead, InsightsLiveFloorplan, InsightsLiveKioskFooter } from '@dms/component'
import { useCompany, useStore } from 'zens-store'
import { useTranslation } from 'react-i18next'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: Spacing.XL,
    backgroundColor: Color.simplyWhite,
  },
  head: {},
  floorplan: {
    paddingBottom: Spacing.L,
  },
})

interface Props extends ViewProps {}

const InsightsLiveKiosk = (props: Props) => {
  const { style, ...otherProps } = props
  const { message } = useStore()
  const { t } = useTranslation()
  const [{ companyId, buildingId, floorId, rotation = 0 }, setNumberParams] = useNumberParams()
  const [{ locked }, setLocked] = useBooleanParams()
  const { width, height } = useWindowDimensions()
  const company = useCompany({ companyId })

  useKeyboardShortcut(['ctrl', 'l'], toggleLock)
  useKeyboardShortcut(['ctrl', 'r'], rotate)

  const floorplanStyle = {
    width: width - Spacing.XL * 2,
    height: height - Spacing.L * 2 - 120, // Header height,
  }

  function toggleLock() {
    setLocked({ locked: !locked })
    message.add({
      message: locked ? t('Kiosk is unlocked successfully') : t('Kiosk is locked successfully '),
      status: 'success',
    })
  }

  function rotate() {
    setNumberParams({ rotation: ((rotation || 0) + 270) % 360 })
  }

  function renderScreen() {
    return (
      <>
        <InsightsLiveKioskHead companyId={companyId} floorId={floorId} style={styles.head} />
        <InsightsLiveFloorplan
          companyId={companyId}
          buildingId={buildingId}
          floorId={floorId}
          colorScheme={company.data!.colorScheme}
          style={[styles.floorplan, floorplanStyle]}
          disabled
          autoRefresh
          rotation={rotation as 0 | 90 | 180 | 270}
        />
        <InsightsLiveKioskFooter colorScheme={company.data!.colorScheme} />
      </>
    )
  }

  if (locked)
    return (
      <View style={[styles.container, style]} {...otherProps}>
        {renderScreen()}
      </View>
    )

  return (
    <Link
      style={[styles.container, style]}
      href={{ pathname: `/companies/${companyId}/insights/${buildingId}/floors/${floorId}/live`, params: { rotation } }}
      asChild
    >
      <TouchableOpacity {...otherProps}>{renderScreen()}</TouchableOpacity>
    </Link>
  )
}

export default InsightsLiveKiosk
